/* ============================================================
   EXALLAXE · /pages/politicas
   Scroll suave entre âncoras + estado ativo do índice via IntersectionObserver
   ============================================================ */

(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  function init() {
    var indice = document.querySelector('.politicas-indice');
    if (!indice) return;

    var links = indice.querySelectorAll('.politicas-indice__link');
    if (!links.length) return;

    // ----------------------------------------------------------
    // Detecta a altura do header do tema Dawn e seta CSS var
    // para posicionar a sidebar/topbar abaixo dele
    //
    // Importante: o Shopify atribui .shopify-section-group-header-group
    // a CADA section dentro do group (announcement, header) como irmãos,
    // não a um wrapper único. Por isso precisamos iterar TODOS e pegar o
    // bottom mais baixo do conjunto.
    // ----------------------------------------------------------
    function detectHeaderOffset() {
      var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      var offset = 0;

      // 1ª tentativa: somar TODAS as sections do header group
      var groupSections = document.querySelectorAll(
        '.shopify-section-group-header-group, .shopify-section-header-group'
      );

      if (groupSections.length > 0) {
        var maxBottom = 0;
        var anySticky = false;
        for (var i = 0; i < groupSections.length; i++) {
          var el = groupSections[i];
          if (el.offsetHeight === 0) continue;
          var r = el.getBoundingClientRect();
          if (r.bottom > maxBottom) maxBottom = r.bottom;
          var p = window.getComputedStyle(el).position;
          if (p === 'sticky' || p === 'fixed') anySticky = true;
        }

        if (isDesktop) {
          offset = maxBottom;
        } else if (anySticky) {
          offset = maxBottom;
        }
      }

      // 2ª tentativa: fallback para outros seletores se nada foi detectado
      if (offset === 0 && isDesktop) {
        var headerSelectors = [
          '.header-wrapper',
          'header[role="banner"]',
          '.shopify-section-header',
          'sticky-header'
        ];

        var header = null;
        for (var j = 0; j < headerSelectors.length; j++) {
          header = document.querySelector(headerSelectors[j]);
          if (header && header.offsetHeight > 0) break;
          header = null;
        }

        if (header) {
          var rect = header.getBoundingClientRect();
          offset = Math.max(rect.bottom, header.offsetHeight);
        } else {
          offset = 200;
        }
      }

      // Margem de segurança para evitar tangência exata na border-bottom
      if (offset > 0 && isDesktop) {
        offset += 8;
      }

      document.documentElement.style.setProperty(
        '--politicas-header-offset',
        offset + 'px'
      );
    }

    detectHeaderOffset();
    window.addEventListener('resize', detectHeaderOffset);
    window.addEventListener('load', detectHeaderOffset);

    // ----------------------------------------------------------
    // Limita a altura da sidebar ao bottom do bloco contato
    // para não sobrepor o footer global do Dawn
    // ----------------------------------------------------------
    function adjustIndiceBottom() {
      if (!window.matchMedia('(min-width: 1024px)').matches) {
        indice.style.maxHeight = '';
        return;
      }

      var contato = document.querySelector('.politicas-contato');
      if (!contato) {
        indice.style.maxHeight = '';
        return;
      }

      var contatoRect = contato.getBoundingClientRect();
      var contatoBottom = contatoRect.bottom;

      var headerOffsetStr = getComputedStyle(document.documentElement)
        .getPropertyValue('--politicas-header-offset');
      var headerOffset = parseInt(headerOffsetStr, 10) || 130;

      var availableHeight = contatoBottom - headerOffset;
      var viewportHeight = window.innerHeight - headerOffset;

      if (availableHeight < viewportHeight) {
        indice.style.maxHeight = Math.max(0, availableHeight) + 'px';
      } else {
        indice.style.maxHeight = '';
      }
    }

    adjustIndiceBottom();
    window.addEventListener('scroll', adjustIndiceBottom, { passive: true });
    window.addEventListener('resize', adjustIndiceBottom);
    window.addEventListener('load', adjustIndiceBottom);

    // ----------------------------------------------------------
    // Scroll suave + offset para sticky em mobile
    // ----------------------------------------------------------
    function getScrollOffset() {
      // Em mobile, descontar a altura do índice sticky horizontal
      if (window.matchMedia('(max-width: 1023px)').matches) {
        return indice.offsetHeight + 8;
      }
      return 24;
    }

    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var alvo = document.querySelector(href);
        if (!alvo) return;

        event.preventDefault();
        var top = alvo.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();

        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({ top: top, behavior: 'smooth' });
        } else {
          window.scrollTo(0, top);
        }

        // Atualiza a URL sem recarregar
        if (history.replaceState) {
          history.replaceState(null, '', href);
        }
      });
    });

    // ----------------------------------------------------------
    // Estado ativo via IntersectionObserver
    // ----------------------------------------------------------
    var secoes = document.querySelectorAll('.politicas-secao');
    if (!secoes.length || typeof IntersectionObserver === 'undefined') return;

    var linkMap = {};
    Array.prototype.forEach.call(links, function (link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        linkMap[href.slice(1)] = link;
      }
    });

    function clearActive() {
      Array.prototype.forEach.call(links, function (link) {
        link.classList.remove('is-active');
      });
    }

    function setActive(id) {
      var link = linkMap[id];
      if (!link) return;
      clearActive();
      link.classList.add('is-active');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        // Encontra a primeira seção com maior interseção visível
        var maisVisivel = null;
        var ratioMax = 0;

        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > ratioMax) {
            ratioMax = entry.intersectionRatio;
            maisVisivel = entry.target;
          }
        });

        if (maisVisivel && maisVisivel.id) {
          setActive(maisVisivel.id);
        }
      },
      {
        // Considera "ativa" a seção cujo topo passou da metade superior do viewport
        rootMargin: '-20% 0px -60% 0px',
        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
      }
    );

    Array.prototype.forEach.call(secoes, function (secao) {
      if (secao.id) {
        observer.observe(secao);
      }
    });

    // Estado inicial: ativar primeira seção se já está visível
    var primeira = secoes[0];
    if (primeira && primeira.getBoundingClientRect().top < window.innerHeight) {
      setActive(primeira.id);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();